'use strict';

angular.module('userRequestEditControllers')

.controller('TaskCardsController', ['$scope', '$state', 'editAccessRequestService', 'businessSystemService', 'existingSysRoles', 'arrayHelpers', function ($scope, $state, editAccessRequestService, businessSystemService, existingSysRoles, arrayHelpers) {

    // Need refresh
    $scope.needRefresh = false;

    $scope.refresh = function () {
        $state.go($state.current, {}, { reload: true });
    }

    $scope.$on('needRefresh', function () {
        $scope.needRefresh = true;
    });

    // Get pendings
    $scope.pendings = $scope.userRequest.SystemRolePendings;

    // Get existings (and merge with pendings)
    var existings = existingSysRoles;
    $scope.existings = editAccessRequestService.mergePendingsAndExistingsRoles($scope.pendings, existings);

    // Network shares or not
    $scope.pendingsNetworkShares = _.filter($scope.pendings, { SystemTypeID: 4 });

    var pendingsNotNetworkShares = _.difference($scope.pendings, $scope.pendingsNetworkShares);
    $scope.groupsOfPendings = arrayHelpers.getGroupsOfArrays(businessSystemService.systemRole.bySystem(pendingsNotNetworkShares), 2);
}]);